/**
 * Published events of the Grid V2 A/B test (Grid V2 Tracking Spec).
 */
import type { TripCategory } from "@overrides/types";
import type { GridV2Screen } from "../raw/GridV2RawEvent";

export enum GridV2EventName {
  grid_v2_opted_out = "grid_v2_opted_out",
}

/**
 * The opt-out event the A/B test PRD requires. One event per attempt,
 * `success` tells a recorded opt-out from a failed call; a user can succeed
 * only once (no opt back in). After a success the global `grid_version`
 * reads v1 and `grid_v2_opted_out` true on later events.
 */
export interface GridV2OptedOutEvent {
  name: GridV2EventName.grid_v2_opted_out;
  properties: {
    success: boolean;
    failure_reason?: string;
    screen: GridV2Screen;
    trip_type?: TripCategory;
    origin?: string;
    destination?: string;
    [bffProperty: string]: unknown;
  };
}

export type GridV2Event = GridV2OptedOutEvent;
